// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-timestamp[data-v-79119dd4] .action-text__longtext-wrapper{padding:0}`, "",{"version":3,"sources":["webpack://./src/components/MessagesList/MessagesGroup/Message/MessageButtonsBar/MessageButtonsBar.vue"],"names":[],"mappings":"AACA,gEACC,SAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
